import { createContext, useContext, useEffect, useRef } from 'react';

const PullToRefreshContext = createContext(null);

export function PullToRefreshProvider({ children }) {
  const refreshFnRef = useRef(null);
  return (
    <PullToRefreshContext.Provider value={refreshFnRef}>
      {children}
    </PullToRefreshContext.Provider>
  );
}

export function usePullToRefreshRef() {
  return useContext(PullToRefreshContext);
}

export function useRegisterRefresh(fn) {
  const ref = useContext(PullToRefreshContext);
  useEffect(() => {
    if (!ref) return;
    ref.current = fn;
    return () => { ref.current = null; };
  }, [fn, ref]);
}
